<template>
  <svg width="13"
       height="14"
       viewBox="0 0 13 14"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 12.625L0.874999 12.625L0.874999 9.5M9 12.625L12.125 12.625L12.125 9.5"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M6.5 0.750001L6.5 5.9375C6.49643 6.2704 6.55938 6.60066 6.68517 6.9089C6.81095 7.21714 6.99704 7.49715 7.2325 7.7325L12.125 12.625M4.625 8.875L0.874999 12.625"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    }
  }
}
</script>
<svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">

  </svg>
